import React from "react";

export const SortDIcons = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="10"
      viewBox="0 0 19 10"
    >
      <g id="sort-descending" transform="translate(-3 -4)">
        <g id="Group_12140" data-name="Group 12140">
          <path
            id="Path_225434"
            data-name="Path 225434"
            d="M13,13H4a1,1,0,0,1,0-2h9a1,1,0,0,1,0,2Z"
            fill="#4c5a6a"
          />
        </g>
        <g id="Group_12141" data-name="Group 12141">
          <path
            id="Path_225435"
            data-name="Path 225435"
            d="M10,8H4A.945.945,0,0,1,3,7,.945.945,0,0,1,4,6h6a.945.945,0,0,1,1,1A.945.945,0,0,1,10,8Z"
            fill="#4c5a6a"
          />
        </g>
        <g id="Group_12142" data-name="Group 12142">
          <path
            id="Path_225436"
            data-name="Path 225436"
            d="M18,14a.945.945,0,0,1-1-1V5a1,1,0,0,1,2,0v8A.945.945,0,0,1,18,14Z"
            fill="#4c5a6a"
          />
        </g>
        <g id="Group_12143" data-name="Group 12143">
          <path
            id="Path_225437"
            data-name="Path 225437"
            d="M21,9a.908.908,0,0,1-.7-.3L18,6.4,15.7,8.7a.99.99,0,0,1-1.4-1.4l3-3a.967.967,0,0,1,1.4,0l3,3a.967.967,0,0,1,0,1.4A.908.908,0,0,1,21,9Z"
            fill="#4c5a6a"
          />
        </g>
      </g>
    </svg>
  );
};
